export default function a11yProps(index: number, uniqueId: string = 'config') {
  return {
    id: `${uniqueId}-tab-${index}`,
    'aria-controls': `${uniqueId}-tabpanel-${index}`
  }
}
